// extracted by mini-css-extract-plugin
export default {"paginationWrapper":"styles_paginationWrapper__Tygr2","root":"styles_root__UAN47","caption":"styles_caption__3CT8n"};